// @flow
import { map, values, reverse } from "ramda"
import * as React from "react"
import type { HOC } from "recompose"
import withQuery from "hoc/withQuery"
import Page from "pages/_Page"
import { PageTitle } from "componentsStyled/Typography/Titles"
import { VPaddedFullWidthContainer } from "componentsStyled/Layout/Containers"
import Tabs from "components/Tabs"
import ReservationsList from "components/ReservationList"
import { Offset } from "componentsStyled/Layout/Offset"
import { reservationListQuery } from "data/reservations/graphql/queries"

const Reservations = ({ data }) => {
  const groups = {
    upcoming: reverse(data.confirmed || []),
    current: data.checked_out || [],
    past: data.finished || [],
    cancelled: data.cancelled || [],
  }
  const currentEmpty = groups.current.length === 0
  const nonEmptyIndex = currentEmpty
    ? values(groups).findIndex(x => x.length)
    : 1 // if possible, select current reservations tab

  const tabs = map(
    x => (
      <Offset>
        <ReservationsList reservations={x} />
      </Offset>
    ),
    groups,
  )

  return (
    <Page>
      <VPaddedFullWidthContainer>
        <PageTitle>Reservations</PageTitle>
        <Tabs
          tabs={tabs}
          startingIndex={nonEmptyIndex === -1 ? 0 : nonEmptyIndex}
          centerSwitch
        />
      </VPaddedFullWidthContainer>
    </Page>
  )
}

const enhancer: HOC<*, {||}> = withQuery(reservationListQuery, {
  noEmpty: true,
})

export default enhancer(Reservations)



// WEBPACK FOOTER //
// ./src/pages/Reservations/index.js